import QAndAPaginatedContainer from './QAndAPaginatedContainer.component';

export default QAndAPaginatedContainer;